import React, { useContext, useEffect, useState } from "react";
import { FaPlay } from "react-icons/fa";
import DashboardContainer from "../Container";
import { TimeBookingContext } from "../../../context/TimebookingContext";
import { ITsZeiteintrag, requestLetzteZeiteintraege } from "../../Timesafe/timesafeApiCalls";
import "../style-lists.scss";

function formatDuration(min: number): string {
    const hours = Math.floor(min / 60);
    const minutes = min % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")} h`;
}

function formatDate(datum: string): string {
    const date = new Date(datum);
    return isNaN(date.getTime()) ? "" : date.toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit" });
}

function projektLabel(e: ITsZeiteintrag): string {
    return [e.projektNr, e.projektBezeichnung].filter(Boolean).join(" ");
}

function taetigkeitLabel(e: ITsZeiteintrag): string {
    return e.taetigkeitBezeichnungMitGruppen || e.taetigkeitBezeichnung || `#${e.taetigkeitID}`;
}

// The last own timebookings from TimeSafe (default 5). A click clocks in again on the same activity
// (from now on), with the text of last time (can be changed when clocking out).
function ContainerLatestTimeBookings(props: { classes: string; anzahl?: number }) {
    const anzahl = props.anzahl ?? 5;
    const { isActive, beginTimeBooking } = useContext(TimeBookingContext);
    const [eintraege, setEintraege] = useState<ITsZeiteintrag[]>([]);
    const [laden, setLaden] = useState<boolean>(true);
    const [fehler, setFehler] = useState<string>("");

    // Load on start and reload when clocking in/out (after clocking out a new booking is in TimeSafe)
    useEffect(() => {
        requestLetzteZeiteintraege(anzahl)
            .then((liste) => {
                setEintraege(liste ?? []);
                setFehler("");
            })
            .catch((error) => {
                console.error(error);
                setFehler(`Buchungen konnten nicht geladen werden: ${error?.message ?? error}`);
            })
            .finally(() => setLaden(false));
    }, [isActive, anzahl]);

    const handleClick = (e: ITsZeiteintrag) => {
        beginTimeBooking(e.taetigkeitID, e.textExtern ?? "", `${projektLabel(e)} – ${taetigkeitLabel(e)}`);
    };

    const bookingList = eintraege.map((e) => (
        <div
            key={e.id}
            className={`ds-list__item ds-list__item--4 ds-list__item--clickable ${isActive ? "disabled" : ""}`}
            title={isActive ? "Es läuft bereits eine Zeitbuchung" : "Diese Buchung jetzt erneut starten"}
            onClick={() => handleClick(e)}>
            <span className="ds-list__primary" title={projektLabel(e)}>
                <FaPlay className="ds-list__play" /> {projektLabel(e)}
            </span>
            <span title={taetigkeitLabel(e)}>{taetigkeitLabel(e)}</span>
            <span>
                {formatDate(e.datum)} · {formatDuration(e.dauerInMinuten)}
            </span>
            <span title={e.textExtern ?? ""}>{e.textExtern}</span>
        </div>
    ));

    let inhalt: React.ReactNode = bookingList;
    if (fehler) inhalt = <div className="ds-list__empty ds-list__error">{fehler}</div>;
    else if (laden) inhalt = <div className="ds-list__empty">Buchungen werden geladen ...</div>;
    else if (bookingList.length === 0) inhalt = <div className="ds-list__empty">Keine Buchungen vorhanden</div>;

    return (
        <DashboardContainer headerName="LATEST TIMEBOOKINGS" className={`ds-list ds-latesttimebookings ${props.classes}`}>
            <div className="ds-list__head ds-list__item--4">
                <span>Projekt</span>
                <span>Tätigkeit</span>
                <span>Zeit</span>
                <span>Text</span>
            </div>
            {inhalt}
        </DashboardContainer>
    );
}

export default ContainerLatestTimeBookings;
